export default function Nav() {
  return (
    <header className="nav">
      <div className="nav-inner">
        <a className="brand" href="#top">
          <span className="brand-mark" aria-hidden />
          <span>
            Easy School <span className="brand-name">Payments</span>
          </span>
        </a>
        <nav className="nav-links" aria-label="Primary">
          <a href="#features">Features</a>
          <a href="#how-it-works">How it works</a>
          <a href="#pricing">Pricing</a>
          <a href="#contact" className="btn btn-primary btn-small">
            Request a demo
          </a>
        </nav>
      </div>
    </header>
  );
}
